<template>
    <section>
        <div class="hero-container tw-relative">
            <figure class="overlay tw-pointer-events-none tw-absolute lg:tw-top-0">
                <img src="~@/assets/img/hero-overlay.png">
                <img :src="`https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/courses/${$route.params.course}/hero.jpg`">
            </figure>
            <div class="content tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-center lg:tw-justify-between lg:tw-container">
              <div class="form-container tw-relative">
                <div class="course-info">
                  <span>CURSO:</span>
                  <h3>{{$store.state.courseInfo.humanFriendlyName}}</h3>
                </div>
                <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                <FormSuccess v-if="$store.state.formSuccess" >
                </FormSuccess>
              </div>
            </div>
        </div>
        <div class="professional tw-relative tw-py-8 lg:tw-py-16">
            <div class="tw-container">
<!--                <div class="tw-text-center tw-pt-6 lg:tw-pt-0">-->
<!--                    <h2>Saídas Profissionais</h2>-->
<!--                </div>-->
                <div class="tw-grid tw-grid-cols-1 tw-pt-8 lg:tw-grid-cols-2 lg:tw-pt-20 lg:tw-gap-5">
                    <div>
                        <div class="tw-relative" v-if="$store.state.courseInfo.saidasProfissionais">
                            <p class="tw-pb-4 lg:tw-pb-6 tw-z-50">Possíveis saídas profissionais:</p>
                            <ul>
                                <li v-for="saida in $store.state.courseInfo.saidasProfissionais" :key="saida">
                                    {{ saida }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div class="tw-relative tw-pt-16 lg:tw-pt-0" v-if="$store.state.courseInfo.empregadores">
                            <p class="tw-pb-4 lg:tw-pb-6">Entidades empregadoras:</p>
                            <ul>
                                <li v-for="empregador in $store.state.courseInfo.empregadores" :key="empregador">
                                    {{ empregador }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="">
                        <div v-if="$store.state.courseInfo.funcoes">
                            <p class="tw-pb-6 lg:tw-pb-6">Funções que poderão ser desempenhadas:</p>
                            <ul>
                                <li v-for="funcao in $store.state.courseInfo.funcoes" :key="funcao">
                                    {{ funcao }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="logo tw-container tw-pt-6 lg:tw-pt-12">
                <div class="tw-grid tw-grid-cols-3 tw-gap-6 lg:tw-grid-cols-6 lg:tw-gap-0">
                    <div class="tw-items-center tw-justify-center" v-for="sponsor in $store.state.courseInfo.sponsors" :key="sponsor" >
                        <img :src="`https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/brands/${sponsor}`">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    components: {
        Form,
        FormSuccess,
    },
    methods: {
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
        redirectToCourse() {
            this.$router.push({ path: `/${slugify(this.selectedCourse).toLowerCase()}` });
        },
    },
    mounted() {
        axios
            .get(`https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/courses/${this.$route.params.course}/info.json`)
            .then((response) => {
                this.$store.state.courseInfo = response.data;
                this.$store.state.selectedCourse = response.data.code;
                console.log(response.data);
            })
            .catch(() => {
                this.$router.push('/');
            });
    },
};
</script>
<style lang="scss">
@import '@/assets/scss/course.scss';

</style>
